let csrfToken: string | null = null;

export function getCsrfToken(): string | null {
  return csrfToken;
}

export function setCsrfToken(nextToken: string | null): void {
  csrfToken = nextToken;
}

export function clearCsrfToken(): void {
  csrfToken = null;
}
